import { useState, useEffect, useRef } from 'react';
import { useParams, NavLink, useLocation, Link } from 'react-router-dom';
import { getTranslate } from '../../../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../../../utils/getLocatPath/getLocalPath';
import { isExternalLink } from '../../../../utils/isExternalLink/isExternalLink';
import styles from '../Header.module.scss';
import logo from '../../../../assets/img/logo/main.jpg';

export const Menu = ({ upHeader, setIsMobMenu, getFilterUrlLink }) => {
  const [activeIdx, setActiveIdx] = useState(false);
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const { pathname } = useLocation();
  const menuRef = useRef(null);
  const upMenu = upHeader.acf.menu;

  const getPath = (targetLang) => {
    return pathname.replace(/^\/(ru|kk)/, `/${targetLang}`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveIdx(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = (idx) => {
    setActiveIdx(activeIdx === idx ? null : idx);
  };

  const renderItems = (items) => {
    return (
      <ul className={styles.menu_submenu_list}>
        {items.map((el, idx) => {
          const { title, link } = el;
          const isLink = isExternalLink(link);
          return isLink ? (
            <li key={idx} className={styles.menu_submenu_item}>
              <a href={link} target="_black" onClick={() => setActiveIdx(false)} className={styles.menu_submenu_link}>
                {title[lang]}
              </a>
            </li>
          ) : (
            <li key={idx} className={styles.menu_submenu_item}>
              <NavLink to={l(link, lang)} onClick={() => setActiveIdx(false)} className={styles.menu_submenu_link}>
                {title[lang]}
              </NavLink>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <nav className={styles.menu}>
      <div className="container">
        <div className={styles.menu_body}>
          <div className={styles.menu_logo}>
            <NavLink to={l('', lang)} className={styles.menu_logo_body}>
              <div className={styles.menu_logo_img}>
                <img src={logo} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
              <div className={styles.menu_logo_text}>
                <span>{t('Орталық балалар кітапханасы', 'Центральная детская библиотека', lang)}</span>
                <span>{t('Оралхан Бөкей атындағы · Өскемен', 'им. Оралхана Бокея · Өскемен', lang)}</span>
              </div>
              <div className={styles.menu_logo_text_mobile}>
                <span>{t('ОКЖ', 'ЦБС', lang)}</span>
              </div>
            </NavLink>
          </div>
          <ul className={styles.menu_menu} ref={menuRef}>
            {upMenu.map((el, idx) => {
              const { title, menu, link } = el;
              const isOpen = activeIdx === idx;
              return !link ? (
                <li key={idx} className={styles.menu_menu_item}>
                  <div onClick={() => handleToggle(idx)} className={`${styles.menu_menu_text} ${isOpen ? 'active' : ''}`}>
                    {title[lang]}
                    <span>▾</span>
                  </div>
                  <div className={`${styles.menu_submenu} ${isOpen ? 'active' : ''}`}>
                    <div className={styles.menu_submenu_body}>{renderItems(menu)}</div>
                  </div>
                </li>
              ) : (
                <li key={idx} className={styles.menu_menu_item}>
                  <a href={link} target="_black" className={`${styles.menu_menu_text} ${isOpen ? 'active' : ''}`}>
                    {title[lang]}
                  </a>
                </li>
              );
            })}
          </ul>
          <div className={styles.menu_lang}>
            <Link to={getPath('kk')} className={`${styles.menu_lang_btn} ${lang === 'kk' ? 'active' : ''}`}>
              Қаз
            </Link>
            <Link to={getPath('ru')} className={`${styles.menu_lang_btn} ${lang === 'ru' ? 'active' : ''}`}>
              Рус
            </Link>
          </div>
          <div className={styles.menu_burger}>
            <div onClick={() => setIsMobMenu(true)} className={styles.menu_burger_img}>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
